import { Model } from '@/app/shared/models/model';

export class RefundExternal extends Model {
  public TenantId?: string;
  public Code?: string;
  public CovenantId?: string;
  public CovenantDescription?: string;
  public CovenantTenantId?: string;
  public Active?: boolean;
  public AllRefunds?: boolean = false;
}
